import React, { useContext, useEffect, useState } from "react";
import Layout from "components/sales/layout/layout";
import localization from "assets/localization/localization";
import { BaseUrl } from "contexts/baseUrl/baseUrl";
import "bootstrap/dist/css/bootstrap.min.css";
import "./incentive.css";
import { Button } from "react-bootstrap";
import axios from "services/interceptor/Interceptor";
import Config from "services/config/config";
import ModalPop from "components/sales/modal/modal";
import Images from "assets/images/imageData";

const ValetIncentive = ({
  history,
  valetIncentiveListing,
  incentiveListData,
  match,
}) => {
  const { baseUrl } = useContext(BaseUrl);
  const [isLoading, setIsLoading] = useState(false);
  const [incentiveList, setIncentiveList] = useState([]);
  const [gridData, setGridData] = useState([]);
  const [transposedData, setTransposeData] = useState([]);
  const [isEditing, setIsEditing] = useState(false);
  const [editableData, setEditableData] = useState([]);
  const [isModal, setIsModal] = useState(false);
  const [error, setError] = useState(null);
  const [userId, setUserId] = useState(null);
  const [projectId, setProjectId] = useState(null);
  const [role, setRole] = useState(null);
  const [status, setStatus] = useState("OPS_APPROVED");
  const [isRejectModal, setIsRejectModal] = useState(false);

  useEffect(() => {
    if (
      incentiveListData !== undefined &&
      incentiveListData !== null &&
      incentiveListData !== ""
    ) {
      // console.log("sdjfhs",incentiveListData);
      setIncentiveList(incentiveListData);
      setGridData(incentiveListData?.grid_data);
      setUserId(incentiveListData?.user_id);
      setProjectId(incentiveListData?.project_id);
      setRole(incentiveListData?.role);
      // "user_id": 231350,
      // "project_id": 1,
      // "role": "driver",
    }
  }, [incentiveListData]);

  useEffect(() => {
    const localDate = localStorage.getItem("filterDataIncentive");
    let filterDataObj = JSON.parse(localDate);
    let toDate = filterDataObj.to_date;
    let fromDate = filterDataObj.from_date;

    (async () => {
      setIsLoading(true);
      valetIncentiveListing(
        match.params.user_id,
        fromDate,
        toDate,
        match.params.project_id,
        1
      );
      setIsLoading(false);
    })();
  }, []);

  useEffect(() => {
    const table = document.querySelector(".table-container");
    const firstRow = document.querySelector(".incentive-thead");
    const firstColumnCells = document.querySelectorAll(".fixed-column");

    const updateScroll = () => {
      if (!table || !firstRow || !firstColumnCells) {
        console.error("One or more DOM elements are missing.");
        return;
      }
    
      const scrollTop = table.scrollTop;
      const scrollLeft = table.scrollLeft;
    
      // Apply transformations only if elements exist
      if (firstRow) {
        firstRow.style.transform = `translateY(${scrollTop}px)`;
      }
    
      if (firstColumnCells) {
        firstColumnCells.forEach((cell) => {
          if (cell) {
            cell.style.transform = `translateX(${scrollLeft}px)`;
          }
        });
      }
      // const scrollTop = table.scrollTop;
      // const scrollLeft = table.scrollLeft;

      // firstRow.style.transform = `translateY(${scrollTop}px)`;
      // firstColumnCells.forEach((cell) => {
      //   cell.style.transform = `translateX(${scrollLeft}px)`;
      // });
    };

    table.addEventListener("scroll", updateScroll);

    return () => {
      table.removeEventListener("scroll", updateScroll);
    };
  }, []);

  const handleDateCheckboxChange = (transactionDate, rowIndex) => {
    const updatedGridData = gridData?.map((item) => {
      if (item.transaction_date === transactionDate) {
        item.breakdown_data = Object.keys(item.breakdown_data).reduce(
          (acc, key) => {
            acc[key] = {
              ...item.breakdown_data[key],
              is_checked: !item.breakdown_data[key]?.is_checked,
            };
            return acc;
          },
          {}
        );
      }
      return item;
    });

    setGridData(updatedGridData);
  };

  const handleEarningTypeCheckboxChange = (eventType, cellIndex) => {
    const updatedGridData = gridData?.map((item) => {
      Object.keys(item.breakdown_data).forEach((key) => {
        if (item.breakdown_data[key].earning_type === eventType) {
          item.breakdown_data[key].is_checked =
            !item.breakdown_data[key].is_checked;
        }
      });
      return item;
    });

    // Update the state
    setGridData(updatedGridData);
  };

  const handleToggleAllCheckboxes = (eventType, transactionDate) => {
    const updatedGridData = gridData?.map((item) => {
      if (item.transaction_date === transactionDate) {
        Object.keys(item.breakdown_data).forEach((key) => {
          if (item.breakdown_data[key].earning_type === eventType) {
            item.breakdown_data[key].is_checked =
              !item.breakdown_data[key].is_checked;
          }
        });
      }
      return item;
    });

    setGridData(updatedGridData);
  };

  useEffect(() => {
    const newTransposedData =
      incentiveList?.grid_data && incentiveList.grid_data.length > 0
        ? incentiveList.grid_data.reduce((acc, rowData) => {
            Object.keys(rowData.breakdown_data).forEach((earningType) => {
              if (!acc[earningType]) {
                acc[earningType] = [];
              }
              acc[earningType].push({
                transaction_date: rowData.transaction_date,
                earning_id: rowData.breakdown_data[earningType].earning_id,
                total_amount_approved:
                  rowData.breakdown_data[earningType].total_amount_approved,
                total_amount_earned:
                  rowData.breakdown_data[earningType].total_amount_earned,
                status: rowData.breakdown_data[earningType].status,
                is_processed: rowData.breakdown_data[earningType].is_processed,
                is_checked: rowData.breakdown_data[earningType].is_checked,
              });
            });
            return acc;
          }, {})
        : {};

    setTransposeData(newTransposedData);
  }, [incentiveList]);

  const formatDate = (dateString) => {
    const dateObject = new Date(dateString);
    const day = dateObject.getDate().toString().padStart(2, "0");
    const month = (dateObject.getMonth() + 1).toString().padStart(2, "0");
    const year = dateObject.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const handleEditClick = () => {
    setIsEditing(true);
    setEditableData([...incentiveList.grid_data]);
  };

  const handleCancelEdit = () => {
    setIsEditing(false);
    setEditableData([]);
  };

  const handleSaveEdit = () => {
    setIsEditing(false);
    setEditableData([]);
  };

  const handleEditDataChange = (event, rowIndex, field) => {
    const updatedEditableData = [...gridData];
    updatedEditableData[rowIndex].breakdown_data[field].total_amount_approved =
      event.target.value;
    setGridData(updatedEditableData);
  };

  const handleApproveClick = async (e) => {
    e.preventDefault();

    const payload = {
      gridData,
      userId,
      status: "OPS_APPROVED",
      role,
      projectId,
    };

    setIsLoading(true);
    const url = `${Config.postSales.editIncentiveData}`;
    try {
      const response = await axios.post(url, payload);
      if (
        response?.data !== undefined &&
        parseInt(response.data?.status) === 200
      ) {
        setIsModal(true);
      } else {
        setIsModal(true);
        setError(response.data?.message);
      }
    } catch (error) {
      console.error("Error saving data:", error);
    }
    setIsLoading(false);
  };

  const handleRejectClick = async (e) => {
    e.preventDefault();

    const payload = {
      gridData,
      userId,
      status: "OPS_REJECTED",
      role,
      projectId,
    };

    setIsLoading(true);
    const url = `${Config.postSales.editIncentiveData}`;
    try {
      const response = await axios.post(url, payload);
      if (
        response?.data !== undefined &&
        parseInt(response.data?.status) === 200
      ) {
        setIsRejectModal(true);
      } else {
        setIsRejectModal(true);
        setError(response.data?.message);
      }
    } catch (error) {
      console.error("Error reject data:", error);
    }
    setIsLoading(false);
  };

  const handleModalHide = () => {
    window.location.reload();
    setIsModal(false);
  };

  const handleRejectModalHide = () => {
    window.location.reload();
    setIsRejectModal(false);
  };

  return (
    <Layout
      title={localization.valetIncentive}
      isGoback={true}
      Buttons={() =>
        isEditing ? (
          <>
            <Button
              className="filter-hamburger btn btn-transparent"
              onClick={handleCancelEdit}
            >
              {localization.cancel}
            </Button>
            <Button
              className="filter-hamburger btn btn-transparent"
              onClick={handleSaveEdit}
            >
              {localization.save}
            </Button>
          </>
        ) : (
          <>
            <Button
              className="filter-hamburger btn btn-transparent"
              onClick={handleEditClick}
            >
              {localization.edit}
            </Button>
            <Button
              className="filter-hamburger btn btn-danger"
              onClick={handleRejectClick}
            >
              {localization.reject}
            </Button>
            <Button
              className="filter-hamburger btn btn-success"
              onClick={handleApproveClick}
            >
              {localization.approve}
            </Button>
          </>
        )
      }
      isLoading={isLoading}
    >
      <ModalPop
        title={localization.success}
        show={isModal}
        handleModalHide={handleModalHide}
        keyboard
      >
        <div className="text-center">
          <div className="success">
            <img src={Images?.tick} alt="" />
          </div>

          <h5>{localization.dataApproved}</h5>
        </div>
      </ModalPop>

      <ModalPop
        title={localization.success}
        show={isRejectModal}
        handleModalHide={handleRejectModalHide}
        keyboard
      >
        <div className="text-center">
          <div className="success">
            <img src={Images?.tick} alt="" />
          </div>

          <h5>{"Rejected Sucessfully"}</h5>
        </div>
      </ModalPop>

      <div className="table-container">
        {incentiveList?.grid_data ? (
          <table className="table-responsive">
            <thead className="incentive-thead">
              <tr className="table-border">
                <th className="table-border text-center fixed-column">
                  <img src={Images?.Incentive} width="100px" alt="" />
                </th>
                {Object.keys(transposedData).map((earningType, cellIndex) => (
                  <th
                    key={cellIndex}
                    colSpan="2"
                    className="table-border incentive-cell-padding text-center"
                  >
                    <label
                      htmlFor={`earningtype${earningType}`}
                      className="label-style"
                    >
                      {earningType}
                    </label>
                    <br />
                    <button
                      className="btn btn-sm type-btn"
                      onClick={() =>
                        handleEarningTypeCheckboxChange(earningType, cellIndex)
                      }
                    >
                      Check all
                    </button>
                  </th>
                ))}
              </tr>
            </thead>
            <tbody className="table-body">
              {gridData &&
                gridData?.map((rowData, rowIndex) => (
                  <tr key={rowIndex} className="table-border">
                    <td className="table-border incentive-cell-padding incentive-thead fixed-column">
                      <label className="label-new-style">
                        <strong>{formatDate(rowData.transaction_date)}</strong>
                      </label>
                      <button
                        className="btn btn-sm head-btn"
                        onClick={() =>
                          handleDateCheckboxChange(
                            rowData.transaction_date,
                            rowIndex
                          )
                        }
                      >
                        Check all
                      </button>
                    </td>
                    {Object.keys(transposedData).map((rowType, cellIndex) => (
                      <React.Fragment key={cellIndex}>
                        <td
                          colSpan="2"
                          className="table-border incentive-cell-padding"
                          style={{
                              backgroundColor:
                                rowData?.breakdown_data?.[rowType]?.status == "OPS_APPROVAL_PENDING"
                                  ? "white"
                                  : rowData?.breakdown_data?.[rowType]?.status == "OPS_APPROVED"
                                  ? "lightgreen"
                                  : rowData?.breakdown_data?.[rowType]?.status == "OPS_REJECTED"
                                  ? "lightcoral"
                                  : "",
                            }}
                        >
                          <div className="parent-style">
                            {rowData.breakdown_data[rowType] &&
                            rowData.breakdown_data[rowType].status &&
                            rowData.breakdown_data[rowType].status !== "OPS_APPROVED" &&
                            rowData.breakdown_data[rowType].status !== "OPS_REJECTED" &&
                            rowData.breakdown_data[rowType].status !==
                              "NOT_APPLICABLE" ? (
                              <>
                                <input
                                  className="parent-input"
                                  type="checkbox"
                                  id={`amountearned${rowType}${rowIndex}`}
                                  name={`amountearned${rowType}${rowIndex}`}
                                  checked={
                                    rowData.breakdown_data[rowType]?.is_checked
                                      ? `1`
                                      : ``
                                  }
                                  onChange={() =>
                                    handleToggleAllCheckboxes(
                                      rowType,
                                      rowData.transaction_date
                                    )
                                  }
                                />
                                <label
                                  htmlFor={`amountearned${rowType}${rowIndex}`}
                                  className="label-new-style"
                                >
                                  {isEditing &&
                                  rowData.breakdown_data[rowType] &&
                                  rowData.breakdown_data[rowType].is_checked ? (
                                    <input
                                      type="text"
                                      className="disabled-input input-textbox"
                                      value={
                                        rowData.breakdown_data[rowType]
                                          .total_amount_approved
                                      }
                                      onChange={(event) =>
                                        handleEditDataChange(
                                          event,
                                          rowIndex,
                                          rowType
                                        )
                                      }
                                    />
                                  ) : (
                                    <>
                                      {
                                        rowData.breakdown_data[rowType]
                                          .total_amount_approved
                                      }
                                    </>
                                  )}
                                  <br />
                                </label>
                              </>
                            ) : (
                              <div className="zero">
                                {
                                  rowData.breakdown_data[rowType]
                                    .total_amount_approved
                                }
                              </div>
                            )}
                          </div>
                        </td>
                      </React.Fragment>
                    ))}
                  </tr>
                ))}
            </tbody>
          </table>
        ) : (
          <div>
            {/*{localization.noRecord}*/}
            <img src={Images?.NoData} alt="" width="100%" />
          </div>
        )}
      </div>
    </Layout>
  );
};

export default ValetIncentive;
